import { fetch, post } from '@/utils/axios'

export default {
    // 首页热门产品列表
    getHomeHotList: (params) => {
        return fetch('/base/product/getHomeHotList', params)
    },
    // 产品列表
    getProductList: (params) => {
        return fetch('/base/product/getProductList', params)
    },
    // 查询默认产品id
    getDefaultProductId: (params) => {
        return fetch('/base/product/getDefaultProductId', params)
    },
    // 产品详情
    getProductInfo: (params) => {
        return fetch('/base/product/getProductInfo', params)
    },
    // 查询产品成交列表
    getProductDealList: (params) => {
        return fetch('/base/product/getProductDealList', params)
    },
    // 查询自选产品列表
    getOptionalProductList: (params) => {
        return fetch('/base/product/getOptionalProductList', params)
    },
    // 批量添加自选产品
    addOptionalProduct: (data) => {
        return post('/base/product/addOptionalProduct', data)
    },
    // 单独添加删除自选产品
    editSingleOptionalProduct: (params) => {
        return fetch('/base/product/editSingleOptionalProduct', params)
    },
    // 理财产品列表
    getFinanceProductList: (params) => {
        return fetch('/base/productFinance/getFinanceProductList', params)
    },
    // 理财产品详情
    getFinanceProductInfo: (params) => {
        return fetch('/base/productFinance/getFinanceProductInfo', params)
    },
    // 查询C2C供应商销售模板列表
    getSalesTemplateList: (params) => {
        return fetch('/base/vendor/getSalesTemplateList', params)
    },
    // 查询C2C供应商销售模板详情数据
    getSalesTemplateInfo: (params) => {
        return fetch('/base/vendor/getSalesTemplateInfo', params)
    },
    // 获取秒合约期限
    getSecondYield: (params) => {
        return fetch('/base/product/getSecondYield', params)
    },
}